export default __webpack_public_path__ + "a8b192cd9f54f602176a00f05af7221f.png";